// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeometryType } from "./GeometryType";
import {
  GeometryTypeFromJSON,
  GeometryTypeFromJSONTyped,
  GeometryTypeToJSON,
  GeometryTypeToJSONTyped,
} from "./GeometryType";

/**
 *
 * @export
 * @interface VectorLayer
 */
export interface VectorLayer {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  type?: GeometryType;
}

/**
 * Check if a given object implements the VectorLayer interface.
 */
export function instanceOfVectorLayer(value: object): value is VectorLayer {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function VectorLayerFromJSON(json: any): VectorLayer {
  return VectorLayerFromJSONTyped(json, false);
}

export function VectorLayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): VectorLayer {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    type: json["type"] == null ? undefined : GeometryTypeFromJSON(json["type"]),
  };
}

export function VectorLayerToJSON(json: any): VectorLayer {
  return VectorLayerToJSONTyped(json, false);
}

export function VectorLayerToJSONTyped(
  value?: VectorLayer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    type: GeometryTypeToJSON(value["type"]),
  };
}
